import React from 'react';
import { Badge } from '@superops/ui-design-system';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const sentimentSeverityMapping = {
  VERY_POSITIVE: 'success',
  POSITIVE: 'success',
  NEUTRAL: 'warning',
  NEGATIVE: 'critical',
  VERY_NEGATIVE: 'critical',
  NO_SENTIMENT: 'gray'
};

export const knownIssuesSeverityMapping = {
  NONE: 'success',
  COSMETIC: 'success',
  LOW: 'attention',
  MODERATE: 'warning',
  HIGH: 'critical',
  SEVERE: 'critical',
  CRITICAL: 'critical'
};

export const stabilitySeverityMapping = {
  STABLE: 'success',
  NEUTRAL: 'warning',
  CAUTION: 'critical'
};

type SeverityType = 'sentiment' | 'knownIssues' | 'stability';

interface CombinedSeverityCellProps {
  cell: any;
  severityType: SeverityType;
}

function CombinedSeverityCell(props: CombinedSeverityCellProps) {
  const { cell, severityType } = props;
  const flags = useFlags();
  const cellOriginal = cell?.row?.original;

  let severity: string;
  let mapping: Record<string, string>;
  const dataObject = cell?.row?.original?.patchDetail
    ? cell?.row?.original?.patchDetail
    : cell?.row?.original;
  switch (severityType) {
    case 'sentiment':
      severity = dataObject?.sentiment?.severity;
      mapping = sentimentSeverityMapping;
      break;
    case 'knownIssues':
      severity = dataObject?.knownIssues?.severity;
      mapping = knownIssuesSeverityMapping;
      break;
    case 'stability':
      severity = dataObject?.stabilitySeverity
      mapping = stabilitySeverityMapping;
      break;
    default:
      severity = cell?.value || '';
      mapping = {};
  }

  return (
    <span
      onClick={() => {
        if (
          cell?.column?.actions?.handlePatchSummaryModal &&
          flags?.patchClassicView
        ) {
          cell?.column?.actions?.handlePatchSummaryModal({
            patchId:
              cellOriginal?.patchId || cellOriginal?.patchDetail?.patchId,
            kbNumber: cellOriginal?.patchDetail
              ? cellOriginal.patchDetail.kbNumbers[0]?.kbNumber
              : cellOriginal?.kbNumbers[0]?.kbNumber
          });
        }
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      className="cursor-pointer"
    >
      <Badge size="large" uppercase status={mapping[severity] || 'none'}>
        {severity?.split('_')?.join(' ') || <DisabledTag>NA</DisabledTag>}
      </Badge>
    </span>
  );
}

export default CombinedSeverityCell;
